import { DBMessageLogThunks, messageLogSelectByQuery } from "@common-reducers/DBServiceThunks";
import CampaignMessageLogSentRow from './campaign-message-log-sent-row';
import LazyLoadingVirtuoso from '../../lazy-loading-virtuoso';
import { cn } from "@/lib/utils";

interface CampaignSentLogsProps {
    campaignId: string;
    filterSelector: (state: any) => any;
}

export const CampaignSentLogs = ({ campaignId, filterSelector }: CampaignSentLogsProps) => {

    return (
        <div
            className={cn(
                "flex flex-col gap-1",
                // Outer card border removed — the rows carry their own dividers; the
                // frame just boxed in empty space below a short list. Surface kept.
                "rounded-md overflow-hidden",
                "h-full max-h-[calc(100vh-340px)]",
                "p-1.5",
                "bg-[var(--color-bg)] dark:bg-[var(--color-bg)]"
            )}
        >
            <LazyLoadingVirtuoso
                isFullWidth={true}
                height={500}
                rowHeightString='72px'
                filterObj={{ campaignId }}
                DBThunks={DBMessageLogThunks}
                DBReducer={state => state.DBMessageLogReducer}
                selectByQuery={messageLogSelectByQuery}
                selector={filterSelector}
                Component={CampaignMessageLogSentRow}
                featchData={false}
            />
        </div>
    );
};

export default CampaignSentLogs;